import { useEffect, useState } from "react";
import { Divider } from "@mui/material";
import SwapHorizOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";
import useCurrentUserCache from "src/hooks/useCurrentUserCache";
import useAuth from "src/hooks/useAuth";
import {
  clearCacheFLFHomeIndex,
  deployCacheFLFHomeIndex,
  getCacheFLFHomeIndex,
} from "src/apis/FLF/homeIndex.api";
import {
  NotifyClearCache,
  NotifyDeployCache,
} from "src/components/notify/Notify";
import { allowedDeployCache } from "src/constants/role";
import Controls from "src/components/form/controls/Controls";
import { currentUserHandleCache } from "src/utils/helper";

const CreateCache = ({ listDataCache, localUser, currentUserCache }) => {
  return (
    <div>
      <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
        {currentUserHandleCache(localUser, currentUserCache)}
        {`vừa tạo ${listDataCache.length} homeIndex`}
      </p>
      {listDataCache.map((data, index) => (
        <p
          key={data.id}
          style={{ padding: "10px", fontWeight: "bold", color: "#0069A9" }}
        >
          {`${index + 1}. ${data.category?.name}`}
        </p>
      ))}
    </div>
  );
};

const UpdateCache = ({ listDataCache, localUser, currentUserCache }) => {
  return (
    <div>
      <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
        {currentUserHandleCache(localUser, currentUserCache)}
        {`vừa cập nhật ${listDataCache.length} homeIndex`}
      </p>
      {listDataCache.map((data, index) => (
        <p
          key={data.id}
          style={{ padding: "10px", fontWeight: "bold", color: "#d68102" }}
        >
          {`${index + 1}. ${data.category?.name}`}
        </p>
      ))}
    </div>
  );
};

const DeleteCache = ({ listDataCache, localUser, currentUserCache }) => {
  return (
    <div>
      <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
        {currentUserHandleCache(localUser, currentUserCache)}
        {`vừa xóa ${listDataCache.length} homeIndex`}
      </p>
      {listDataCache.map((data, index) => (
        <p
          key={data.id}
          style={{ padding: "10px", fontWeight: "bold", color: "#fb0b12" }}
        >
          {`${index + 1}. ${data.category?.name}`}
        </p>
      ))}
    </div>
  );
};

const SortCache = ({ listDataCache, localUser, currentUserCache }) => {
  return (
    <div>
      <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
        {currentUserHandleCache(localUser, currentUserCache)}
        {`vừa sắp xếp các homeIndex, thứ tự thực hiện`}
      </p>
      {listDataCache.map((data, index) => (
        <div
          key={index}
          style={{
            margin: "10px 0",
            display: "flex",
            justifyContent: "space-around",
          }}
        >
          <span
            style={{
              padding: "10px",
              fontWeight: "bold",
              color: "#d68102",
              width: "40%",
            }}
          >
            {`${index + 1}. ${data.activeHomeIndex?.category?.name}`}
          </span>
          <SwapHorizOutlinedIcon />
          <span
            style={{
              padding: "10px",
              fontWeight: "bold",
              color: "#d68102",
              width: "40%",
            }}
          >
            {`${data.overHomeIndex?.category?.name}`}
          </span>
        </div>
      ))}
    </div>
  );
};

const objectActionCache = {
  Create: CreateCache,
  Update: UpdateCache,
  Delete: DeleteCache,
  Sort: SortCache,
};

const RenderCache = ({
  listDataCache,
  actionCache,
  localUser,
  currentUserCache,
}) => {
  if (actionCache) {
    return objectActionCache[actionCache]({
      listDataCache,
      localUser,
      currentUserCache,
    });
  }
  return null;
};

const ShowCacheFLFHomeIndex = () => {
  const [listDataCache, setListDataCache] = useState([]);
  const [modelCache, setModelCache] = useState();
  const [actionCache, setActionCache] = useState();

  const { currentUserCache } = useCurrentUserCache();

  const { auth } = useAuth();

  useEffect(() => {
    getCacheFLFHomeIndex((result) => {
      setListDataCache(result.data);
      setModelCache(result.model);
      setActionCache(result.action);
    });
  }, []);

  const handleDeployData = () => {
    NotifyDeployCache(
      "warning",
      "Deploy Data ?",
      "<h5> Tất cả dữ liệu mới sẽ được lưu </h5>",
      (result) => {
        if (result.isConfirmed) {
          deployCacheFLFHomeIndex((result) => {
            window.location.reload(true);
          });
        }
      }
    );
  };

  const handleClearData = () => {
    NotifyClearCache(
      "warning",
      "Clear Cache ?",
      "<h5> Tất cả dữ liệu mới sẽ được hủy bỏ </h5>",
      (result) => {
        if (result.isConfirmed) {
          clearCacheFLFHomeIndex((result) => {
            window.location.reload(true);
          });
        }
      }
    );
  };

  return (
    <>
      <RenderCache
        listDataCache={listDataCache}
        modelCache={modelCache}
        actionCache={actionCache}
        localUser={auth}
        currentUserCache={currentUserCache}
      />
      <Divider sx={{ width: "100%" }} />
      {allowedDeployCache(
        currentUserCache?.email,
        auth?.email,
        auth?.permissions
      ) ? (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Controls.Button
            sx={{
              width: "150px",
              marginTop: "10px",
            }}
            color="secondary"
            type="button"
            text="Clear Cache"
            onClick={handleClearData}
          />
          <Controls.Button
            sx={{ width: "150px", marginTop: "10px", marginLeft: "10px" }}
            type="button"
            text="Deploy Data"
            onClick={handleDeployData}
          />
        </div>
      ) : null}
    </>
  );
};

export default ShowCacheFLFHomeIndex;
